import { IProductState } from "../../models/product.interface";
import { ProductsAction } from "../actions/products.actions";
import { initialState } from "../reducers/root.reducer";
import { ProductsActionTypes } from "../actions/types";



export const productsReducer = (
  state: IProductState  = initialState.products,
  action: ProductsAction
) => {
  switch (action.type) {
    case ProductsActionTypes.GET_PRODUCTS_COMPLETED:
      return action.payload;
    case ProductsActionTypes.GET_PRODUCTS_FAILED:
      return {products: [], error: new Date()}
    default:
      return state;
  }
};
